import { Directive, ElementRef, EventEmitter, HostListener, Input, Output } from '@angular/core';

declare const $;

@Directive({
	selector: '[appDrag]'
})
export class DragDirective {
	@Output() stopped = new EventEmitter<any>();
	@Input() disabled;

	startX = 0;
	startY = 0;
	x = 0;
	y = 0;
	width = 0;
	height = 0;
	pictureHeight = 0;
	clientWidth = 0;
	mouseDown = false;

	@HostListener('mousedown', ['$event'])
	onMousedown(event) {
		this.x = $(this.el.nativeElement)[0].offsetLeft;
		this.y = $(this.el.nativeElement)[0].offsetTop;
		this.width = $(this.el.nativeElement)[0].clientWidth;
		this.height = $(this.el.nativeElement)[0].clientHeight;
		this.pictureHeight = $(this.el.nativeElement).parent()[0].clientHeight;
		this.clientWidth = $(this.el.nativeElement).parent()[0].clientWidth;

		if (this.x === 0) {
			this.x = 1;
		}
		if (this.y === 0) {
			this.y = 1;
		}

		this.startX = event.screenX - this.x;
		this.startY = event.screenY - this.y;
		if (!this.disabled) {
			this.mouseDown = true;
		}
	}

	@HostListener('document:mousemove', ['$event'])
	onMousemove(event: MouseEvent) {
		if (this.mouseDown) {
			this.y = this.y > 0 ? event.screenY - this.startY : 0;
			this.x = this.x > 0 ? event.screenX - this.startX : 0;
			if (this.x + this.width >= 1180) {
				this.x = 1180 - this.width;
			}
			if (this.x + this.width >= this.clientWidth) {
				this.x = this.clientWidth - this.width;
			}
			if (this.y + this.height >= this.pictureHeight) {
				this.y = this.pictureHeight - this.height;
			}

			$(this.el.nativeElement).css({
				top: this.y + 'px',
				left: this.x + 'px',
				'background-position': -this.x + 'px ' + -this.y + 'px'
			});
			this.stopped.emit({ top: this.y, left: this.x });
		}
	}

	@HostListener('document:mouseup')
	onMouseup() {
		if (this.mouseDown) {
			this.mouseDown = false;
			this.stopped.emit({ top: this.y, left: this.x });
		}
	}

	constructor(private el: ElementRef) {
		$(this.el.nativeElement).css({
			position: 'absolute'
		});
	}
}
